import { Component, ElementRef, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import {Constants} from 'src/app/shared/utils/constants';
import {IBService} from '../ib.service';
import { ToastrService } from 'ngx-toastr';
import * as moment from 'moment';
import { NgForm } from '@angular/forms';
import { getTimeRemoveTimezoneOffset } from 'src/app/shared/utils/helper';
import { Permission } from 'src/app/models/permission.model';
import { MatDialog } from '@angular/material/dialog';
import { AppService } from 'src/app/app.service';
import { AffiliateService } from 'src/app/components/affiliate/affiliate.service';
import { Affiliate } from 'src/app/models/affiliate.model';
import { AccountService } from 'src/app/shared/services/account.service';

const DEFAULT_CONDITION = {
  keyword: '',
    filter:'',
    search_by:'user_id',
    order: 'desc',
    orderBy: undefined,
    from: undefined,
    to: undefined
}
@Component({
  selector: 'fx-top-list',
  templateUrl: './top-list.component.html',
  styleUrls: ['./top-list.component.sass'],
  providers: [AccountService,AffiliateService]
})
export class TopListIBComponent implements OnInit {
  @ViewChild('form') form: NgForm;
  @Input() permission: Permission;
  @Output() selectIB = new EventEmitter();
  @ViewChild('confirmInvalidate') confirmInvalidateRef: TemplateRef<unknown>;
  @ViewChild('modalEditRank', { static: false }) modalEditRank: ElementRef;
  currency = 'jpy';
  data: any[] = [];
  condition: any = {...DEFAULT_CONDITION};
  switchRadio:number = 0;
  pageInfo: any = {
    pageSize: 10,
    pageIndex: 1,
    pageManual: 1,
    totalRecord: 0,
  };
  subscriptions: any = {};

  model ={ user_id: null, keep: 0 ,rank: null};
  rankName:string;
  selectedData: any;
  selectedIB: any;
  selectedType =
  [
    {
      value:0,
      label:"Standard"
    },
    {
      value:1,
      label:"Organic"
    }
  ]
  loading = false;
  itemIB: any = {};
  isEdit = false;
  currentIndexEdit = null;
  currentUserGroup = {};
  selectedAccount: any = {};
  selectedRank =[];
  selectedItem: any;
  fixedNumber = Constants.FIXED_NUMBER;
  currentAccount: Affiliate = null;
  totalTrainingLot:number =0;
  expiryDate:string;
  currentDate: Date;
  showError = false
  sort: any = {
    id: 'desc',
    username: 'desc',
    email: 'desc',
    status: 'desc'
  };
  isExpandAll = false;
  searchType =
  [
    {
      value:'user_id',
      name:"ID"
    },
    {
      value:'name',
      name:"Username"
    },
    {
      value:'name_jp',
      name:"Username(JP)"
    },
    {
      value:'email',
      name:"Email"
    }

  ]
  constructor(
    private service: IBService,
    private rankingService:AffiliateService,
    private appService: AppService,
    private readonly dialog: MatDialog,
    private readonly accountService: AccountService,
    private readonly toast: ToastrService
  ) {}

  ngOnInit(): void {
    this.getListAffiiates();
    this.currentDate =new Date(new Date().getFullYear(), new Date().getMonth(), 1);//lấy ra ngày đầu tiên của tháng

  }
  getTotalTrainingLot(userId:number){
    this.service.getTotaTraininglLot(userId).subscribe((res) => {
      if (res.status === Constants.RESPONSE_STATUS.SUCCESS) {
        this.selectedData.total_lot = res.data.total_lot;
      }
    });
  }

  openConfirmInvalidateDialog(account: Affiliate): void {
    this.currentAccount = account;
    this.dialog.open(this.confirmInvalidateRef, {
        backdropClass: 'custom-backdrop-color'
    }).afterClosed().subscribe((e) => this.currentAccount = null);
  }



  sorting(column: string): void {
    // tslint:disable-next-line:no-unused-expression
    this.sort[column] = this.sort[column] === 'desc' ? 'asc' : 'desc';
    this.condition.orderBy = column;
    this.condition.order = this.sort[column];
    this.getListAffiiates();
  }

  export(){
    if(this.condition.from && !this.condition.to || this.condition.to && !this.condition.from || this.condition.to<this.condition.from) {
      this.showError = true;
      return
    }
    this.showError = false;
    if(this.condition.from && this.condition.to){
      this.exportByFilter();
    }else{
      this.exportAllData()
    }
  }

  exportAllData() {
    this.service.exportAffiliates({
      is_export: 1,
      order_type: 'desc',
      order_by: 'user_id',
    }).subscribe();
  }

  exportByFilter() {
    let params={
      q: this.condition.keyword
        ? encodeURIComponent(this.condition.keyword.trim())
        : this.condition.keyword.trim(),
      filter:this.condition.filter,
      search_by: this.condition.search_by,
      order_type: this.condition.order,
      order_by: this.getOrder(),
      page: this.pageInfo.pageIndex,
      page_size: this.pageInfo.pageSize,
      from: getTimeRemoveTimezoneOffset(this.condition.from),
      to: getTimeRemoveTimezoneOffset(this.condition.to),
      is_export: 1
    }
    this.subscriptions.getExport =  this.service.exportAffiliates(params).subscribe();
  }

  onInvalidate(): void {
    this.accountService.disableAccountStatus(this.currentAccount.userId.toString()).subscribe({
      next: r => {
        if(r.status === 1000) {
          this.toast.success(`Disable successfully!`, '', {positionClass: 'toast-top-center'});
          this.getListAffiiates();
        } else {
          this.toast.error(`Something went wrong!`, '', {positionClass: 'toast-top-center'})
        }
      }
    });
  }

  getOrder(): string {
    switch (this.condition.orderBy) {
      case 'id':
        return `user_id`;
      case 'email':
        return `email`;
      case 'username':
        return `name`;
      case 'status':
        return `active`;
      default:
        return `user_id`;
    }
  }

  public getListAffiiates(): void {
    const params = {
      q: this.condition.keyword
        ? encodeURIComponent(this.condition.keyword.trim())
        : this.condition.keyword.trim(),
      filter:this.condition.filter,
      search_by: this.condition.search_by,
      order_type: this.condition.order,
      order_by: this.getOrder(),
      page: this.pageInfo.pageIndex,
      page_size: this.pageInfo.pageSize
    };
    this.service.getAffiliates(params).subscribe((res) => {
      if (res.status === Constants.RESPONSE_STATUS.SUCCESS) {
        this.data = res.data.map((v) => {
          this.isExpandAll ? v.isExpand = true : v.isExpand = false ;
          return v;
        }),
        this.pageInfo.totalRecord = res.paging.total;
      }
    });
  }

  expandAll(isExpandAll?:boolean){
    if(isExpandAll){
      this.data = this.data.map((v) => {
        v.isExpand = true;
        return v;
      })
    }else{
      this.data = this.data.map((v) => {
        v.isExpand = false;
        return v;
      })
    }
    this.isExpandAll=isExpandAll;
  }

  checkExpandAll(){
    const count = this.data.filter(v => {
      if (v.isExpand) {
        return true;
      }
      return false;
    }).length;
    if(count==this.data.length){
      this.isExpandAll = true;
    }else if(count===0){
      this.isExpandAll = false;
    }
  }

  onRefresh(){
    this.condition = {...DEFAULT_CONDITION};
    this.showError = false;
    this.pageInfo.pageIndex = 1;
    this.pageInfo.pageManual = 1;
    this.isExpandAll=false;
    this.sort = {
      id: 'desc',
      username: 'desc',
      email: 'desc',
      status: 'desc'
    };
    const params = {
      order_type: this.condition.order,
      order_by: this.getOrder(),
      page: this.pageInfo.pageIndex,
      page_size: this.pageInfo.pageSize,
    };
    this.service.getAffiliates(params).subscribe((res) => {
      if (res.status === Constants.RESPONSE_STATUS.SUCCESS) {
        this.data = res.data;
        this.pageInfo.totalRecord = res.paging.total;
      }
    });
  }

  getIB(ib: any): void {
    this.selectedIB = ib;
    this.selectIB.emit(ib);
  }

  getIbInfo(item): void {
    this.currentUserGroup = item;
    this.service.getGroupListByUser(item.userId).subscribe((res) => {
      if (res.status === Constants.RESPONSE_STATUS.SUCCESS) {
        this.itemIB = {
          name: item.email,
          userName: item.getUsername(),
          data: res.data.map((v) => {
            v.data.commission = v.data.commission
              ? +(v.data.commission * 100).toPrecision(2)
              : v.data.commission;
            v.data.rate = v.data.rate
              ? +(v.data.rate * 100).toPrecision(2)
              : v.data.rate;
            return v;
          }),
        };
      }
    });
  }
  getIbMT4Info(item): void {
    this.selectedAccount = undefined;
    this.service.getIBAccountMT4(item.userId).subscribe((res) => {
      if (res.status === Constants.RESPONSE_STATUS.SUCCESS) {
        this.selectedAccount = {
          name: item.email,
          userName: item.getUsername(),
          data: res.data,
        };
      }
    });
  }
  getListIbRanking() {
    this.rankingService.getListIbRanking().subscribe((res) => {
      if (res.status === Constants.RESPONSE_STATUS.SUCCESS) {
        this.selectedRank=  res.data;
      }
    });
  }
  editRank(item){
    this.model.user_id =item.userId;
    //this.model.rank = item.ranking?.id;
    //this.model.keep = item.ranking?.keep;
    //this.model.expire_time = new Date(item.ranking?.expire_date);
    this.rankName=item.ranking?.name;
    this.expiryDate = item.ranking?.expire_date ;
    this.getListIbRanking();
  }
  reset() {
    this.form.reset();
    this.form.resetForm();
  }

  onEdit(item): void {
    if (item) {
      this.isEdit = true;
      this.currentIndexEdit = item.group_config_id;
    } else {
      this.isEdit = false;
      this.currentIndexEdit = null;
      this.getIbInfo(this.currentUserGroup);
    }
  }
  onSave(item): void {
    const body = {
      group_config_id: item.group_config_id,
      user_id: item.user_id,
      rate: item.data.rate / 100,
    };
    this.onSubmitSetting(body);
  }

  onSubmitSetting(body): void {
    this.service.updateRateIb(body).subscribe((res) => {
      if (res.status === Constants.RESPONSE_STATUS.SUCCESS) {
        this.appService.showSuccess('Update rate success');
        this.isEdit = false;
        this.currentIndexEdit = null;
      } else {
        this.appService.showError('Update rate fail');
      }
    });
  }
  onKeyup(evt: KeyboardEvent): void {
    if (evt.keyCode === 13) {
      this.searchData();
    }
  }

  searchData(): void {
    this.pageInfo.pageIndex = 1;
    this.pageInfo.pageManual = 1;
    this.getListAffiiates();
  }

  pageChanged(page: number): void {
    this.pageInfo.pageIndex = page;
    this.pageInfo.pageManual = page;
    this.getListAffiiates();
  }
  onKeyupPage(evt: KeyboardEvent): void {
    if (evt.keyCode === 13) {
      this.pageInfo.pageIndex = this.pageInfo.pageManual;
      this.getListAffiiates();
    }
  }
  onSelectItem(item: any): void {
    this.selectedData = item;
  }


  onSubmitRank(){
    const data = JSON.parse(JSON.stringify(this.model));
    // data.expire_time  = data.expire_time !== null?  moment(this.model.expire_time).format('YYYY-MM-DD') : null;
    if (!this.form.valid) {
       return ;
    }
    this.appService
    .confirm({
      title: `Are you sure that you want to apply?`,
      ok: 'Yes',
      cancel: 'No',
    })
    .subscribe((res) => {
      if (res?.result) {
        this.service.updateRank(data)
        .subscribe((res) => {
          if (res.status === Constants.RESPONSE_STATUS.SUCCESS) {
            this.appService.showSuccess('IB Ranking has been apply.');
            this.modalEditRank.nativeElement.querySelector('button.close').click();
            this.getListAffiiates();
          } else {
            this.appService.showError('IB Ranking fail.');
          }
        });
      }
    });
  }
  viewType(item) : string {
    return item === 1 ? "Organic" : "Standard";
  }
  ngOnDestroy(): void {
    for (const key in this.subscriptions) {
      if (this.subscriptions.hasOwnProperty(key) && this.subscriptions[key]) {
        this.subscriptions[key].unsubscribe();
      }
    }
  }
}
